import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isAdmin: false,
  isStaff: false,
  isMember: false,
  isGlobal: false,
  assignedPositions: [],
  positions: [],
  assignedLevels: [],
};

const positionSlice = createSlice({
  name: "positionData",
  initialState,
  reducers: {
    // setAssignPositions: (state, action) => {
    //   state.assignedPositions = action.payload || [];
    // },
    // setPositions: (state, action) => {
    //   state.positions = action.payload || [];
    // },
    // setAssignedLevels: (state, action) => {
    //   state.assignedLevels = action.payload || [];
    // },
    // setIsAdmin: (state, action) => {
    //   state.isAdmin = action.payload;
    // },
    // setIsStaff: (state, action) => {
    //   state.isStaff = action.payload;
    // },
    // //I need the function that update all the values together

    setPositionData: (state, action) => {
      return { ...state, ...action.payload };
    },
  },
});

export const { setPositionData } = positionSlice.actions;
export default positionSlice.reducer;
